const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        switchToFrench: 'En Français',
        switchToGerman: 'Auf Deutsch',
        telemedicine: 'Jetzt beitreten',
        joinMeeting: 'Geschätzte Patientinnen und Patienten',
        cancel: 'Abbrechen',
        join: 'Verbinden',
        questionnaire: 'Fragebogen ausfüllen',
    },
    __RELATIVE_SOURCE_FILE__
);
